module.exports = __webpack_public_path__ + "static/img/tabela.01a9ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/guarana-zero/tabela.png
// module id = yFqh
// module chunks = 0